import React from "react";
import { useEmailConfirmation } from "../hooks/useEmailConfirmation";
import EmailConfirmation from "./EmailConfirmation";

interface EmailConfirmationWrapperProps {
  children: React.ReactNode;
}

const EmailConfirmationWrapper: React.FC<EmailConfirmationWrapperProps> = ({
  children,
}) => {
  const {
    showEmailConfirmation,
    handleEmailConfirmationSuccess,
    handleEmailConfirmationPostpone,
    handleCloseEmailConfirmation,
  } = useEmailConfirmation();

  return (
    <>
      {children}
      <EmailConfirmation
        isVisible={showEmailConfirmation}
        onClose={handleCloseEmailConfirmation}
        onSuccess={handleEmailConfirmationSuccess}
        onPostpone={handleEmailConfirmationPostpone}
      />
    </>
  );
};

export default EmailConfirmationWrapper; 